export default "__VITE_ASSET__Bg7wruQr__"